import React, { Component } from "react";
import moment from 'moment';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input
} from "reactstrap";
import Joi from "joi-browser";
import {AgentService } from "../../services";
import httpClient from "../../http-client/client";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import DatePicker from "react-datepicker";

class Logs extends Component {
  constructor(props) {
    super(props);
 
    
  }

  state = {
  fileNameid:'',
  FileNamesList:[],
 logs:''
  };

  //schema
  componentWillMount(){

    this.getFileNames();

   
  }
  componentDidMount() {

this.getFileNames();

  
  }
 

getFileNames = async () => {
  try {
    let { data } =  await httpClient.get(`/logs/`);
  

    this.setState({ FileNamesList: data});
  
  } catch (error) {}
};
getFile = async (id) => {
    
    try {
      let { data } =  await httpClient.get(`/logs/file?id=${id}`);
    
//  console.log(data)
//  data.map(i=>console.log(i))
      this.setState({fileNameid: id,logs:data});
    
    } catch (error) {}
  };


handleSubmit = async (id) => {
  try {
   
  
  
  
  } catch (error) {}
};
handleBack = async (id) => {
  try {
    
    this.props.history.push("/dashboard/Rates");
  } catch (error) {}
};

  render() {
let {  FileNamesList,logs}=this.state;

    const FileNamesList1 = FileNamesList.map(p => (
      <option key={p} value={p}>
        {p}
      </option>
    ));

    return (
   
     <div>

     
          <Form className='row'>


       <div className="row col-md-12">

      
          
                <FormGroup className='col-sm-12 col-md-6'>
                  <Label for='province'>Select File</Label>
                  <Input
                  value={this.state.fileNameid}
                    type='select'
                    name='fileName'
                    id='fileName'
                    // invalid={Boolean(errors['fileName'])}
                    onChange={e => {
                     this.getFile(e.target.value);
                    }}
                  >
                    <option value=''>Select File</option>
                    {FileNamesList1}
                  </Input>
                </FormGroup>
                </div>
               
        
              </Form>
    <div>
        {/* {this.state.logs.map((i)=>{
            return <li>{i}</li>
        })} */}<ol>
 {logs.length>0 && logs.reverse().map(i=>{return(<li style={{justify: "center"}}>{i}</li>)})}
        </ol>
       
    </div>

        {/* toast notifiction */}
        <ToastContainer />
      </div>
    );
  }
}

export default Logs;
